import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stktu } from '../entity/Stktu-angular';

export const StkTu006List = [{ id: "0", name: "ROD" }, { id: "1", name: "IOC" }, { id: "2", name: "FOK" }]; // 委託條件
export const StkTu007List = [{ id: "0", name: "買進" }, { id: "1", name: "賣出" }]; // 買賣
export const StkTu008List = [{ id: "0", name: "否" }, { id: "1", name: "是" }]; // 當沖
export const StkTu009List = [{ id: "0", name: "新倉" }, { id: "1", name: "平倉" }, { id: "2", name: "自動" }]; // 倉別
export const StkTu012List = [{ id: "0", name: "盤中(T盤及T+1盤)" }, { id: "1", name: "T盤預約" }]; // 盤別
export const StkTu028List = [{ id: "1", name: "已暫存" }, { id: "2", name: "委託失敗" }, { id: "3", name: "已刪除" }, { id: "5", name: "委託成功" }, { id: "8", name: "部分成交" }, { id: "9", name: "全部成交" }]; // 狀態
export const StkTu030List = [{ id: "0", name: "上市" }, { id: "1", name: "上櫃" }, { id: "2", name: "期貨" }, { id: "3", name: "選擇權" }, { id: "4", name: "興櫃" }, { id: "5", name: "盤中零股-上市" }, { id: "6", name: "盤中零股-上櫃" }, { id: "O", name: "海期" }, { id: "Z", name: "指數" }]; // 商品分類
export const StkTu014List = [{ id: "2", name: "限價" }, { id: "3", name: "範圍市價" }]; // 委託價類別
export const StkTu015List = [{ id: "1", name: "大於等於" }, { id: "2", name: "小於等於" }]; // 觸發方向
export const StkTu017List = [{ id: "0", name: "一般" }, { id: "MIT", name: "MIT單" }, { id: "STP", name: "STP單" }, { id: "MST", name: "MST單" }, { id: "OCO", name: "OCO單" }, { id: "AB", name: "AB單" }]; // 單別

@Injectable({
  providedIn: 'root'
})
export class StktuServicePkg extends JkEntityV2 {
  StkTu006List = StkTu006List;
  StkTu007List = StkTu007List;
  StkTu008List = StkTu008List;
  StkTu009List = StkTu009List;
  StkTu012List = StkTu012List;
  StkTu028List = StkTu028List;
  StkTu030List = StkTu030List;
  StkTu014List = StkTu014List;
  StkTu015List = StkTu015List;
  StkTu017List = StkTu017List;


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stktu();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      TU001: '交易日期', TU002: '帳號', TU003: '序號', TU005: '商品代號', TU006: '委託條件', TU007: '買賣', TU008: '當沖', TU009: '倉別', TU010: '委託價', TU011: '委託口數', TU012: '盤別', TU018: '登入代號', TU019: '備註', TU020: '暫存', TU021: '失敗原因', TU022: '價差委託', TU023: '更新api', TU024: '委託書號', TU025: '委託序號', TU026: '成交口數', TU027: '異動時間', TU028: '狀態', TU029: '商品名稱', TU030: '商品分類', TU031: '平均成交價', KEY0: '流程碼', TU013: '委託商品年月', TU014: '委託價類別', TU015: '觸發方向', TU017: '單別'
    };

    this.fieldNames = 'TU001,TU002,TU003,TU005,TU006,TU007,TU008,TU009,TU010,TU011,TU012,TU018,TU019,TU020,TU021,TU022,TU023,TU024,TU025,TU026,TU027,TU028,TU029,TU030,TU031,KEY0,TU013,TU014,TU015,TU017';
    this.fieldLengths = { TU001: 8, TU002: 20, TU003: 4, TU005: 20, TU006: 4, TU007: 4, TU008: 4, TU009: 4, TU010: 12, TU011: 8, TU012: 4, TU018: 10, TU019: 255, TU020: 1, TU021: 255, TU022: 1, TU023: 1, TU024: 10, TU025: 13, TU026: 8, TU027: 8, TU028: 1, TU029: 60, TU030: 1, TU031: 11.3, KEY0: 1, TU013: 6, TU014: 1, TU015: 1, TU017: 3 };
    this.columnDefs = [
      { field: "TU029", headerName: "商品名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TU023", headerName: "更新api", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TU024", headerName: "委託書號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TU025", headerName: "委託序號", headerTooltip: "", width: 174, cellDataType: "text", },
      { field: "TU026", headerName: "成交口數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU027", headerName: "異動時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "TU028", headerName: "狀態", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TU022", headerName: "價差委託", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "TU030", headerName: "商品分類", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TU031", headerName: "平均成交價", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "KEY0", headerName: "流程碼", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "TU013", headerName: "委託商品年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "TU014", headerName: "委託價類別", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTu014List }, },
      { field: "TU015", headerName: "觸發方向", headerTooltip: "", width: 80, cellDataType: "number", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.StkTu015List }, },
      { field: "TU017", headerName: "單別", headerTooltip: "", width: 94, cellDataType: "text", },
      { field: "TU001", headerName: "交易日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "TU008", headerName: "當沖", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU002", headerName: "帳號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TU003", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "TU004", headerName: "保留", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TU005", headerName: "商品代號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TU006", headerName: "委託條件", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU007", headerName: "買賣", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU021", headerName: "失敗原因", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TU009", headerName: "倉別", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU010", headerName: "委託價", headerTooltip: "", width: 166, cellDataType: "text", },
      { field: "TU011", headerName: "委託口數", headerTooltip: "", width: 134, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU012", headerName: "盤別", headerTooltip: "", width: 102, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "TU018", headerName: "登入代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "TU019", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "TU020", headerName: "暫存", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKTU';
    this.isSys = false;
    this.sqlSelect = `SELECT STKTU.*  FROM STKTU`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY TU001,TU002,TU003`;
    this.keyFields = ['TU001', 'TU002', 'TU003'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['TU001', 'TU002', 'TU003'];
    this.seqField = 'TU003';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stktu): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stktu): Promise<Stktu> {
    await super.newRecord(newItem);
    return newItem;
  }




}

